import { Component, computed, inject, PLATFORM_ID, signal } from '@angular/core';
import { SignalsStoreService } from '../signals-store.service';
import { OrderService } from '../order.service';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Router } from '@angular/router';
import { BundleEditionTypes } from '../types/order.type';
import { toObservable } from '@angular/core/rxjs-interop';
import { SHOP_BUNDLE_BANNER_DISMISSED_KEY } from './shop-bundle-list.const';

@Component({
    selector: 'app-shop-bundle-list',
    imports: [
        CommonModule
    ],
    templateUrl: './shop-bundle-list.component.html',
    styleUrl: './shop-bundle-list.component.scss'
})
export class ShopBundleListComponent {

  //#region Services

  #signalsStorageService = inject(SignalsStoreService);

  #orderService = inject(OrderService);

  #router = inject(Router);

  #platformId = inject(PLATFORM_ID);

  //#endregion

  //#region Properties

  frequencies = computed(() => this.#signalsStorageService.frequencies());

  bundles = computed(() => this.#orderService.getBundlesLikeSubscriptions());

  dismissed = signal(this.#getInitialDismissedState());

  //#endregion

  //#endregion Constructor

  constructor() {

    toObservable(this.bundles)
      .subscribe(bundles => {
        this.#signalsStorageService.numberBundleSubscribed.set(bundles.length);
      });
  }

  //#endregion

  //#region Methods

  handleImageError(event: Event) {
    (event.target as HTMLImageElement).src = 'assets/images/product-placeholder.webp';
  }

  goToCustomBox(id: number) {
    this.#router.navigate(['/shop/custom-box/' + BundleEditionTypes.subscription + '/' + id]);
  }

  dismiss(event: Event) {
    // Prevent the click from bubbling to the section's goToCustomBox handler
    event.stopPropagation();
    this.dismissed.set(true);

    if (isPlatformBrowser(this.#platformId)) {
      sessionStorage.setItem(SHOP_BUNDLE_BANNER_DISMISSED_KEY, 'true');
    }
  }

  #getInitialDismissedState(): boolean {
    if (!isPlatformBrowser(this.#platformId)) return false;
    return sessionStorage.getItem(SHOP_BUNDLE_BANNER_DISMISSED_KEY) === 'true';
  }

  //#endregion
}
